(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-image-with-text-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-expandable-content')) {
    customElements.define(
      'sc-expandable-content',
      class extends HTMLElement {
        constructor() {
          super();
          this.toggleBtn = this.querySelector('.sc-toggle-btn');
          this.contentWrap = this.querySelector('.sc-content-wrap');

          if (this.toggleBtn && this.contentWrap) {
            this.toggleBtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.contentWrap.classList.toggle('sc-is-expanded');
            });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
